import { downloadWorkbook } from '../../../Utilities/xlsxExport';

const DATE_NUM_FMT = 'mm/dd/yyyy';

const toExcelValue = (value, type) => {
    if (value === null || value === undefined) return '';
    if (type === 'boolean') return value ? 'Yes' : 'No';
    return value;
};

export const toExcelRows = (columns, rows) =>
    rows.map(row => Object.fromEntries(columns.map(({ key, type }) => [key, toExcelValue(row[key], type)])));

// Sizes each column to fit its widest value so Excel shows full cell content without the user
// having to manually resize columns after opening the file. Dates are measured by their rendered
// width (DATE_NUM_FMT), not by Date.toString(), which is far longer than what Excel shows.
const displayLength = (value) => (value instanceof Date ? DATE_NUM_FMT.length : String(value ?? '').length);

export const toExcelColumns = (columns, excelRows) =>
    columns.map(({ key, header, type }) => ({
        key,
        header,
        width: Math.max(header.length, ...excelRows.map(row => displayLength(row[key]))) + 2,
        ...(type === 'date' ? { numFmt: DATE_NUM_FMT } : {}),
    }));

// Returns true when the workbook was downloaded, false if building or downloading it failed.
export const exportToExcel = async ({ filename, sheetName, columns, rows }) => {
    try {
        const excelRows = toExcelRows(columns, rows);
        const excelColumns = toExcelColumns(columns, excelRows);
        await downloadWorkbook(`${filename}.xlsx`, [{ name: sheetName, columns: excelColumns, rows: excelRows }]);
        return true;
    } catch (error) {
        console.error('Error exporting product settings:', error);
        return false;
    }
};
